export default {
  siteUrl: process.env.GATSBY_URL || 'https://rapport.leanloop.co.uk/',
}



// WEBPACK FOOTER //
// ./src/config.js